export enum FACADE_GLASS_TYPE {
  FLOAT = 'float',
  TEMPERED = 'tempered',
  LAMINATED = 'laminated',
}
